export default "__VITE_ASSET__eh0UDWxr__"